import { getFeature } from "../utils/features";
import { setEvents } from "./events";
import { isFitGuideEligible } from "../utils/fitGuideEligibility";

export const setFitGuideAnalytics = ({
  brandId,
  productTypeId,
  gender,
  fitTypeId,
  fitGuideUrl,
} = {}) => {
  if (
    !isFitGuideEligible({
      brandId,
      productTypeId,
      gender,
      fitTypeId,
      fitGuideUrl,
    })
  ) {
    return;
  }

  const { isEnabled, getVariables } = getFeature("pdp-visual-fit-guide");

  if (isEnabled() && getVariables()?.bucket === "on") {
    setEvents({ events: ["event364"], trackingName: "pageLoad" });
  }
};
